import React from 'react';

import qs from 'query-string';
import { SubmitHandler } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { LocalStorageKeys } from 'constants/global';
import { FINISH_REGISTRATION_PAGE_TITLE, SIGN_UP_FLOWS } from 'constants/sign-up';
import { FinishRegistrationInput } from 'interfaces';
import { asyncFinishRegistration } from 'modules/auth/action';
import { selectUserEntityData } from 'modules/current-user/selectors';
import { useAppDispatch, useAppSelector } from 'modules/store';
import { AuthLayout, FinishRegistrationForm, HeaderInfo, NeedHelpLink } from 'page-components';
import { getDealDetailsLink, getTitleWithReplacedYourWord } from 'utils';

import {
  RESET_PASSWORD_PAGE_ADDITIONAL_TEXT,
  SET_PASSWORD_AUTH_LAYOUT_CHILDREN_CLASSNAMES,
} from '../constants/reset-password';

const FinishRegistration = () => {
  const dispatch = useAppDispatch();
  const { search } = useLocation();
  const { hash } = useParams();
  const { flow: urlParamsFlow, dealId } = qs.parse(search);
  const { isTypeEntity, entityName } = useAppSelector(selectUserEntityData);
  const navigate = useNavigate();

  const onSubmit: SubmitHandler<FinishRegistrationInput> = async (data) => {
    if (!hash) return;

    try {
      await dispatch(
        asyncFinishRegistration({
          ...data,
          hash,
          flowParams: { flow: Array.isArray(urlParamsFlow) ? urlParamsFlow[0] : urlParamsFlow },
        }),
      ).unwrap();

      if (dealId && urlParamsFlow === SIGN_UP_FLOWS.ACTIVE_DEAL) {
        navigate(getDealDetailsLink(dealId.toString()));
      }
    } catch (error) {
      console.error('Registration failed', error);
    } finally {
      localStorage.removeItem(LocalStorageKeys.SIGN_UP_FLOW_PARAMS);
    }
  };

  return (
    <AuthLayout childrenClassName={SET_PASSWORD_AUTH_LAYOUT_CHILDREN_CLASSNAMES}>
      <HeaderInfo title={FINISH_REGISTRATION_PAGE_TITLE}>
        {getTitleWithReplacedYourWord(RESET_PASSWORD_PAGE_ADDITIONAL_TEXT, entityName, isTypeEntity)}
      </HeaderInfo>
      <FinishRegistrationForm onSubmit={onSubmit} />
      <NeedHelpLink />
    </AuthLayout>
  );
};

export default FinishRegistration;
